export const purchaseTypes = {
  ONE_TIME: 'ONE_TIME',
};
